import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "code-scanner-container" }
const _hoisted_2 = {
  key: 0,
  class: "preview"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "buttons" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Scan QR Code ")
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "code-scanner-dialog" }, [
  /*#__PURE__*/_createElementVNode("div", { id: "code-scanner" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.preview)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("img", {
              src: _ctx.codeImage,
              style: {"object-fit":"cover"}
            }, null, 8, _hoisted_3)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_button, {
          type: "primary",
          size: "small",
          onClick: _withModifiers(_ctx.showCodeScanner, ["prevent"])
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createVNode(_component_el_form_item, {
        prop: "RFID",
        rules: 
				_ctx.validate
					? {
							required: true,
							message: _ctx.trans('message.field_require', _ctx.trans('label.code'))
					  }
					: {}
			
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: _ctx.model.RFID,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model.RFID) = $event)),
            class: "code",
            size: "small"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["rules"])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.codeScanner,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.codeScanner) = $event)),
      title: "Map QR Code For Visitor",
      "append-to-body": true,
      onOpened: _ctx.showScannerPreview,
      onClosed: _ctx.hideScannerPreview
    }, {
      default: _withCtx(() => [
        _hoisted_6
      ]),
      _: 1
    }, 8, ["modelValue", "onOpened", "onClosed"])
  ], 64))
}